<template>
  <div class="container">
    <div class="row justify-content-center">
      <!-- Login -->
      <div v-if="!verifyPage" class="col-md-6 col-sm container">
        <div class="row">
          <div class="col mt-3" :style="{ fontSize: FontSizes.large2 }">
            ログイン
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">社員番号</div>
          <input type="text" class="col-8 input-frame" v-model="userId" />
        </div>
        <div class="row mt-3">
          <div class="col-4">パスワード</div>
          <PasswordInput class="col-8" v-model:password="password" />
          <!--                <input type="password" class="col-8">-->
        </div>
        <div class="row justify-content-end mt-3">
          <button
            class="col-8 btn btn-primary"
            :disabled="!canClickLogin()"
            @click="onClickLogin"
          >
            ログイン
          </button>
        </div>
        <div class="row justify-content-end mt-3">
          <div
            :key="errorFlashSeq"
            class="col-8 warning-message text-center"
            :class="{ 'flash-box': warningMessage }"
          >
            {{ warningMessage }}
          </div>
        </div>
        <div class="row mt-5">
          <div class="col text-right">
            <a href="#" @click.prevent="onClickPWForgetLink"
               :class="{ 'pulse-nudge': forgetLinkPulseActive }"
               @animationend="forgetLinkPulseActive = false"
              >パスワードを忘れた</a
            >
          </div>
        </div>
      </div>
      <!-- Login -->

      <!-- 2FA -->
      <div v-else class="two-fa-container">
        <!-- auth app steps -->
        <div
          v-if="!isAuthApp && selected2faOpt === 'auth_app'"
          class="two-fa-steps"
        >
          <h3 class="text-center" style="font-weight: 600">
            二要素認証によるアカウントの保護
          </h3>
          <p class="text-center" style="margin-bottom: 48px">
            アカウントを保護するために、Authenticatorアプリを設定することをお勧めします。以下の手順に従ってください：
          </p>

          <p
            style="padding: 0; margin: 0; font-weight: 600; margin-bottom: 8px"
          >
            1. Google AuthenticatorやAuthyなどの認証アプリをダウンロードする。
          </p>
          <p
            style="padding: 0; margin: 0; font-weight: 600; margin-bottom: 8px"
          >
            2. アプリを使って下記のQRコードをスキャンする。
          </p>
          <p
            style="padding: 0; margin: 0; font-weight: 600; margin-bottom: 8px"
          >
            3. アプリが生成した6桁のコードを入力する。
          </p>
        </div>
        <!-- end auth app steps -->

        <div
          v-if="isAuthApp || selected2faOpt === 'email'"
          class="two-fa-steps"
        >
          <h3 class="text-center" style="font-weight: 600; margin-bottom: 24px">
            検証コード
          </h3>
          <p v-if="selected2faOpt === 'auth_app'" class="text-center">
            認証アプリに表示されているコードを入力する。
          </p>
          <p v-if="selected2faOpt === 'email'" class="text-center">
            あなたの電子メールに送信された検証コードを入力します。
          </p>
        </div>

        <!-- QR COde -->
        <div
          v-if="
            selected2faOpt === 'auth_app' &&
            !isAuthApp &&
            qrCode?.file_data !== ''
          "
        >
          <img :src="'data:image/jpeg;base64,' + qrCode?.file_data" />
        </div>
        <!-- End QR COde -->

        <div v-if="!isAuthApp && selected2faOpt === 'auth_app'">
          <div
            style="
              width: 100%;
              height: 1px;
              background-color: black;
              margin-top: 12px;
              margin-bottom: 12px;
            "
          ></div>
          <p class="text-center">
            認証アプリを開き、QRコードまたは以下のコードを貼り付けてください。
          </p>
        </div>

        <!-- 2FA Code input -->
        <div class="code-inputs" style="margin-top: 24px">
          <input
            v-for="(digit, index) in digits"
            :key="index"
            type="text"
            class="digit-box"
            maxlength="1"
            v-model="digits[index]"
            @input="onInput(index, $event)"
            @keydown.backspace="onBackspace(index, $event)"
            :ref="(el) => assignInputRef(el, index)"
          />
        </div>
        <!-- End 2FA Code input -->

        <!-- Button -->
        <div
          style="
            display: flex;
            flex-direction: column;
            row-gap: 4px;
            margin-top: 12px;
          "
        >
          <button @click="verify2FaHandler" class="btn btn-primary">
            確認する
          </button>
          <button
            v-if="selected2faOpt === 'email' || !isAuthApp"
            @click="resendCode"
            class="btn text-primary"
            style="font-weight: 700"
          >
            コード再送
          </button>
        </div>

        <div v-if="showResendCodeMsg">
          <p style="color: green;">新しいコードを送信しました</p>
        </div>

        <div
          style="
            width: 240px;
            height: 1px;
            background-color: black;
            margin-top: 12px;
            margin-bottom: 12px;
          "
        ></div>

        <!-- <button
          v-if="selected2faOpt === 'auth_app'"
          @click="() => change2FaOption('email')"
          class="btn text-primary"
          style="border-color: #007bff; color: #007bff; background-color: white"
        >
          電子メールによる認証
        </button>
        <button
          v-if="selected2faOpt === 'email'"
          @click="() => change2FaOption('auth_app')"
          class="btn text-primary"
          style="border-color: #007bff; color: #007bff; background-color: white"
        >
          認証アプリを使う
        </button> -->
        <!-- End Button -->
        <div class="row justify-content-center">
          <div class="d-flex justify-content-end my-0">
            <div
              class="w-full mt-4"
              @click="cancelVerify"
              style="color: #007bff; cursor: pointer"
            >
              キャンセル
            </div>
          </div>
        </div>
      </div>
      <!-- End 2FA -->
    </div>
  </div>
  <PasswordForgetDialog
    :show="showPWForgetDialog"
    :close-dialog="closePWForgetDialog"
  />
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  ref,
  ComponentPublicInstance,
} from 'vue'
import { backendApi } from '@/utils/backend-api'
import { authStore } from '@/stores/auth-store'
import { toastStore } from '@/stores/toast-store'
import { authLevels } from '@/data-models/auth'
import { logoutMessages, subPaths } from '@/utils/consts'
import { useRouter } from 'vue-router'
import { loadingOverlayStateStore } from '@/stores/loading-overlay-state-store'
import { FontSizes } from '@/utils/font-sizes'
import PasswordUpdateDialog from '@/components/PasswordUpdateDialog.vue'
import PasswordInput from '@/components/PasswordInput.vue'
import PasswordForgetDialog from '@/components/PasswordForgetDialog.vue'
import { ApiResponse, LoginFailureValue } from '@/data-models/api-response'

// ログイン失敗時、value.message が無い（=バックエンド未対応/レスポンス不正）場合だけ使う唯一のフォールバック文言。
// 実際の文言は常にバックエンドの value.message が真実のソース。ここに二つ目の文言を増やさないこと。
const GENERIC_LOGIN_FAILURE_MESSAGE = '● ログインできませんでした。'

export default defineComponent({
  name: 'Login',
  components: { PasswordForgetDialog, PasswordInput },
  setup() {
    const userId = ref<string>(''),
      password = ref<string>(''),
      warningMessage = ref<string>(''),
      showPWForgetDialog = ref<boolean>(false)

    // ログイン失敗エラー表示まわり。文言・ロック判定は一切ここで作らない（バックエンドの value.* をそのまま描画するだけ）。
    const errorFlashSeq = ref<number>(0) // 同一文言でも再表示を視覚的に分かるようにする（枠線フラッシュ再生用のkey）
    const forgetLinkPulseActive = ref<boolean>(false) // is_locked時の「パスワードを忘れた」リンクのワンショット・パルス演出

    const router = useRouter()

    // const fontSizeLarge1 = computed( {
    //     'font-size': FontSizes.large1
    // })

    // 2 FA Stuff =================================
    const digits = ref<string[]>(Array(6).fill(''))
    const digitRefs = ref<HTMLInputElement[]>([])
    const isFirstAuth = ref<boolean>(true)
    // Make sure digitRefs has 6 elements
    onMounted(() => {
      if (digitRefs.value.length === 0) {
        digitRefs.value = Array(6).fill(null)
      }
    })
    const assignInputRef = (
      el: Element | ComponentPublicInstance | null,
      index: number
    ) => {
      if (el instanceof HTMLInputElement) {
        digitRefs.value[index] = el
      }
    }
    const verifyPage = ref<boolean>(false)
    const isAuthApp = ref<boolean>(false)
    const showResendCodeMsg = ref<boolean>(false)
    const selected2faOpt = ref<string>('email')
    const qrCode = ref<any>(null)

    const change2FaOption = async (value: string) => {
      selected2faOpt.value = value

      if (value === 'email' || !isAuthApp.value) {
        const apiDataQR = await backendApi.req2Fa(
          userId.value,
          password.value,
          value,
        )
        if (apiDataQR && apiDataQR?.value?.file_data !== '') {
          qrCode.value = apiDataQR?.value
        } else {
          qrCode.value = null
        }
      }
    }

    // Computed with getter/setter like Vue 2
    const totpInput = computed({
      get: () => digits.value.join(''),
      set: (val: string) => {
        digits.value = val
          .split('')
          .slice(0, 6)
          .concat(Array(6).fill(''))
          .slice(0, 6)
      },
    })

    const onInput = (index: number, event: Event) => {
      const input = event.target as HTMLInputElement
      const value = input.value
      // console.log(input.value)

      if (/^\d$/.test(value)) {
        digits.value[index] = value
        if (index < 5 && digitRefs.value[index + 1]) {
          digitRefs.value[index + 1].focus()
        }
      } else {
        digits.value[index] = ''
      }
    }

    const onBackspace = (index: number, event: KeyboardEvent) => {
      if (digits.value[index] === '' && index > 0) {
        digitRefs.value[index - 1]?.focus()
      }
    }

    const cancelVerify = () => {
      verifyPage.value = false
      showResendCodeMsg.value = false
      selected2faOpt.value = 'email'
      warningMessage.value = ''
      userId.value = ''
      password.value = ''
    }

    const verify2FaHandler = async () => {
      // console.log(digits.value.join(""))
      const totp = digits?.value?.join('')

      const apiDataVerify = await backendApi.verify2Fa(
        userId.value,
        password.value,
        selected2faOpt.value,
        totp
      )
      // console.log(apiDataVerify)

      if (apiDataVerify) {
        if (apiDataVerify.isSuccessful) {
          await onLoginSuccess()
        } else {
          authStore.commit('clearAuth')
          authStore.commit('clearToken')

          // console.log(apiDataVerify)

          if (apiDataVerify?.description === 'invalid code') {
            await router.push({
              path: subPaths.LOGGED_OUT,
              query: {
                logout_message: logoutMessages.CODE_INVALID.key,
              },
            })
          } else if (apiDataVerify?.description === 'code expired') {
            await router.push({
              path: subPaths.LOGGED_OUT,
              query: {
                logout_message: logoutMessages.CODE_EXPIRED.key,
              },
            })
          }

          // if (apiDataVerify.value === userIdNotFound) {
          //   warningMessage.value = '● 存在しない社員番号です。'
          //   loadingOverlayStateStore.commit('fadeout')
          // } else if (apiDataVerify.value === passwordNotMatch) {
          //   warningMessage.value = '● パスワードが正しくありません。'
          //   loadingOverlayStateStore.commit('fadeout')
          // } else if (apiDataVerify.value === invalidUserIdFormat) {
          //   warningMessage.value = '● 社員番号の書式が正しくありません。'
          //   loadingOverlayStateStore.commit('fadeout')
          // } else {
          //   await router.push({
          //     path: subPaths.LOGGED_OUT,
          //     query: {
          //       logout_message: logoutMessages.LOGIN_FAILED.key,
          //     },
          //   })
          // }
        }
      }
    }

    const resendCode = async () => {
      const apiDataQR = await backendApi.req2Fa(
        userId.value,
        password.value,
        selected2faOpt.value,
      )
      if (apiDataQR && apiDataQR?.value?.file_data !== '') {
        qrCode.value = apiDataQR.value
      } else {
        qrCode.value = null
      }

      if (apiDataQR.status === 200) { 
        showResendCodeMsg.value = true
        setTimeout(() => {
          showResendCodeMsg.value = false
        }, 5000);
        // toastStore.commit("post", {message: `新しいコードを送信しました`})
      }
    }
    // End 2 FA Stuff =================================

    const canClickLogin = (): boolean => {
      return userId.value.length > 0 && password.value.length > 0
    }

    const onLoginSuccess = async () => {
      warningMessage.value = ''

      switch (authStore.state.auth.authLevel) {
        case authLevels.DIST_STAFF:
          await router.push({
            path: subPaths.MY_PAGE,
            query: {
              staff_id: authStore.state.auth.userId,
            },
          })
          break
        case authLevels.VIEWER:
        case authLevels.DIST_ADMIN:
        case authLevels.ACCOUNTING_ADMIN:
        case authLevels.ADMIN:
        case authLevels.BOARD_MEMBER:
          await router.push(subPaths.HOME)
          break
        default:
      }
    }

    // ログイン失敗時のハンドラ。フロントは value.* をそのまま描画するだけで、閾値・文言・
    // ロック判定は一切持たない（すべてバックエンド側の value.is_locked / is_permanently_locked / message で決定）。
    const onLoginFail = (resp: ApiResponse) => {
      authStore.commit('clearAuth')
      authStore.commit('clearToken')

      const value = resp.value as LoginFailureValue | undefined
      const message = value?.message || GENERIC_LOGIN_FAILURE_MESSAGE

      warningMessage.value = message
      errorFlashSeq.value++ // 同じ文言でも再表示だと分かるよう枠線フラッシュを再生させる
      loadingOverlayStateStore.commit('fadeout')

      if (value?.is_permanently_locked) {
        // 「パスワードリセットページへリダイレクト」に相当する処理。
        // /reset-password はURLのtokenパラメータ必須で、ロックされたユーザーはtokenを持たないため
        // そのまま遷移させると「リンクが無効です」で行き止まりになる。
        // 既存の自己サービス導線（PasswordForgetDialog、メールでのリセット申請）を開く形で代替する。
        showPWForgetDialog.value = true
        return
      }

      if (value?.is_locked) {
        // 「パスワードを忘れた」リンクへのワンショット・パルス演出。恒常的なスタイル変更にはしない
        // （テンプレート側の @animationend でリセットされる）。
        forgetLinkPulseActive.value = true
      }
    }

    const onClickLogin = async () => {
      // loadingOverlayStateStore.commit('switchLoadingState', {
      //   show: true,
      //   message: 'ログイン処理中…',
      // })
      const resp = await backendApi.login(userId.value, password.value)
      // console.log('onClickLogin', resp)

      if (resp && resp?.status === 200) {
        if (resp && resp?.value.is_2fa_required) {
          verifyPage.value = true

          // const isAuthAppAvail = resp?.value.auth_app_available
          // isFirstAuth.value = resp?.value.is_first_auth

          const apiDataQR = await backendApi.req2Fa(
              userId.value,
              password.value,
              'email',
            )
            if (apiDataQR && apiDataQR?.value?.file_data !== '') {
              qrCode.value = apiDataQR.value
            } else {
              qrCode.value = null
            }

          // if (!isAuthAppAvail && resp?.value?.is_first_auth) {
          //   //
          //   const apiDataQR = await backendApi.req2Fa(
          //     userId.value,
          //     password.value,
          //     'auth_app',
          //     resp?.value.is_first_auth
          //   )
          //   if (apiDataQR && apiDataQR?.value?.file_data !== '') {
          //     qrCode.value = apiDataQR.value
          //   } else {
          //     qrCode.value = null
          //   }
          // } else if (isAuthAppAvail) {
          //   //
          //   if (resp.value.auth_app_available) {
          //     isAuthApp.value = true
          //   } else {
          //     isAuthApp.value = false
          //   }
          // } else {
          //   //
          //   const apiDataQR = await backendApi.req2Fa(
          //     userId.value,
          //     password.value,
          //     'email',
          //     resp?.value.is_first_auth
          //   )
          //   if (apiDataQR && apiDataQR?.value?.file_data !== '') {
          //     qrCode.value = apiDataQR.value
          //   } else {
          //     qrCode.value = null
          //   }
          // }
          // if (resp.value.auth_app_available) {
          //   isAuthApp.value = true
          // } else {
          //   isAuthApp.value = false
          // }
        } else {
          await onLoginSuccess()
        }
      } else {
        onLoginFail(resp)
      }

      // if (resp.isSuccessful) {
      //   await onLoginSuccess()
      // } else {
      //   authStore.commit('clearAuth')
      //   authStore.commit('clearToken')

      //   if (resp.value === userIdNotFound) {
      //     warningMessage.value = '● 存在しない社員番号です。'
      //     loadingOverlayStateStore.commit('fadeout')
      //   } else if (resp.value === passwordNotMatch) {
      //     warningMessage.value = '● パスワードが正しくありません。'
      //     loadingOverlayStateStore.commit('fadeout')
      //   } else if (resp.value === invalidUserIdFormat) {
      //     warningMessage.value = '● 社員番号の書式が正しくありません。'
      //     loadingOverlayStateStore.commit('fadeout')
      //   } else {
      //     await router.push({
      //       path: subPaths.LOGGED_OUT,
      //       query: {
      //         logout_message: logoutMessages.LOGIN_FAILED.key,
      //       },
      //     })
      //   }
      // }
    }

    const onClickPWForgetLink = () => {
      showPWForgetDialog.value = true
    }

    const closePWForgetDialog = () => {
      showPWForgetDialog.value = false
    }

    onMounted(() => {
      loadingOverlayStateStore.commit('fadeout')
    })

    return {
      userId,
      password,
      canClickLogin,
      onClickLogin,
      FontSizes,
      warningMessage,
      errorFlashSeq,
      forgetLinkPulseActive,
      onClickPWForgetLink,
      showPWForgetDialog,
      closePWForgetDialog,

      // 2 FA
      verifyPage,
      isAuthApp,
      selected2faOpt,
      change2FaOption,
      showResendCodeMsg,
      qrCode,
      digits,
      digitRefs,
      totpInput,
      onInput,
      onBackspace,
      verify2FaHandler,
      cancelVerify,
      resendCode,
      assignInputRef,
    }
  },
})
</script>

<style scoped lang="scss">
.two-fa-container {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.two-fa-steps {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.code-inputs {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.digit-box {
  width: 48px;
  height: 48px;
  text-align: center;
  font-size: 24px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #e9f2ff;
}

.warning-message {
  color: red;
  border-radius: 4px;
  // バックエンドのmessageに\nが含まれる場合、改行として表示する（{{ }}のテキスト内容はデフォルトで
  // 折り返されて消えてしまうため、v-htmlは使わずCSSのみで対応する）。
  white-space: pre-line;
}

// 同じ文言でも「今回失敗した」ことが分かるよう、再表示のたびに一瞬だけ枠線をフラッシュさせる。
.flash-box {
  animation: warning-flash 0.6s ease-out;
}

@keyframes warning-flash {
  0% {
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.6);
  }
  100% {
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0);
  }
}

// is_locked 時、「パスワードを忘れた」リンクへ注意を引くワンショットのパルス演出。
// 恒常的なスタイル変更にはしない（アニメーション終了時に script 側でクラスを外す）。
.pulse-nudge {
  animation: forget-link-pulse 0.6s ease-in-out 2;
}

@keyframes forget-link-pulse {
  0%,
  100% {
    color: inherit;
    text-shadow: none;
  }
  50% {
    color: #dc3545;
    text-shadow: 0 0 6px rgba(220, 53, 69, 0.5);
  }
}
</style>
